import React, { useState } from 'react';
import PrezziProdotti from './PrezziProdotti';
import AbbinamentiIngredienti from './AbbinamentiIngredienti';
import GrammatureAI from './GrammatureAI';

const SEZIONI = [['prezzi', 'Prezzi prodotti'], ['abbinamenti', 'Abbinamenti'], ['grammature', 'Grammature AI']];

export default function CostiProdotti({ headers }) {
  const [sezione, setSezione] = useState('prezzi');
  return (
    <div className="space-y-3" data-testid="costi-prodotti">
      <div className="inline-flex gap-1 rounded-xl bg-white p-1 border border-gray-200">
        {SEZIONI.map(([id, nome]) => (
          <button key={id} type="button" onClick={() => setSezione(id)} data-testid={`costi-sezione-${id}`}
            className={`px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors ${sezione === id ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-100'}`}>
            {nome}
          </button>
        ))}
      </div>
      {sezione === 'prezzi' && <PrezziProdotti headers={headers} />}
      {sezione === 'abbinamenti' && <AbbinamentiIngredienti headers={headers} />}
      {sezione === 'grammature' && <GrammatureAI headers={headers} />}
    </div>
  );
}
